<nav class="container">
  <div class="terminal">
    Karaoke$ <span [className]="errorType$ | async">{{ error$ | async }}</span>
  </div>
</nav>
